import { useEffect, useState } from "react";
import { Badge, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";

export const StatusPickerInput = ({
  id,
  status,
  options,
  onClick,
  allowSelect,
}: Props) => {
  const [displayStatus, setStatus] = useState("Select Status");
  const statusColors = {
    processed: "green",
    delayed: "red",
    processing: "orange",
    Pending: "yellow",
    Collection: "orange",
    Sorting: "orange",
    Destruction: "red",
    Complete: "green",
    Erasure: "red",
    Sold: "green",
    "Quote Pending": "yellow",
    "Data Destruction": "red",
    "Waiting Collection": "orange",
    "Select Status": "none",
    // Add more status-color mappings here
  };

  useEffect(() => {
    if (status) {
      setStatus(options[status]);
    }
  }, [status]);

  const getKeyByValue = (value) =>
    Object.keys(options).find((key) => options[key] === value);

  return (
    <Menu>
      <MenuButton
        cursor={allowSelect ? "pointer" : "default"}
        as={Badge}
        colorScheme={statusColors[displayStatus]}
      >
        {displayStatus === "Sold" ? "Completed" : displayStatus}
      </MenuButton>
      {allowSelect && (
        <MenuList>
          {Object.values(options).map((value: string) => (
            <MenuItem
              onClick={() => {
                if (onClick) {
                  setStatus(value);
                  onClick(id, getKeyByValue(value));
                }
              }}
              key={value}
              value={value}
            >
              {value}
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Menu>
  );
};

interface Props {
  id: string;
  status: string;
  options: any; //accepts enum
  allowSelect?: boolean;
  onClick?: (id: string, value: string) => void;
}
